export default class Common {
    //表格数据处理方法
    static handleTable(Columns, columnWidth, ismethod, $index) {
        if (Columns != undefined) {
            var keys = [];
            Columns.forEach((item, index) => {
                var obj = {};
                obj.prop = item.fieldname;
                obj.label = item.fieldstring;
                obj.width = columnWidth[index];
                if (item.show == "0") {
                    obj.isShow = false;
                } else {
                    obj.isShow = true;
                }
                if (index == $index) {
                    // alert(ismethod)
                    obj.isfixed = true;
                    obj.fixed = "left";
                    obj.ismethod = ismethod;
                    if (ismethod) {
                        obj.isShowRule = 1;
                    }
                }
                if (item.islevel) {
                    obj.islevel = true;
                }
                if (item.isTypeTab) {
                    obj.isTypeTab = true;
                }
                if (item.isReadStatus) {
                    obj.isReadStatus = true;
                }
                if (item.isqrcode) {
                    obj.iscode = true;
                    obj.isschool = item.isschool;
                }
                if (item.isWxCode) {
                    obj.isWxCode = true;
                    obj.isschool = item.isschool;
                }
                if (item.istag) {
                    obj.istag = true;
                    obj.istag = item.istag;
                }
                obj.align = "center";
                keys.push(obj);
            });

            return keys;
            // this.columns = keys;
        }
    }

    //获取当前时间和之前时间
    static getDate(day) {
        var date1 = new Date(),
            time1 =
            date1.getFullYear() +
            "-" +
            (date1.getMonth() + 1) +
            "-" +
            date1.getDate(); //time1表示当前时间
        var date2 = new Date(date1);
        date2.setDate(date1.getDate() + day);
        var year = date2.getFullYear();
        var month = date2.getMonth() + 1;
        var strDate = date2.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var time2 =
            year +
            "-" +
            month +
            "-" +
            strDate;

        return time2;
    }
    //获取当前日期yy-mm-dd
    //date 为时间对象
    static getDateStr3(date) {
        var year = "";
        var month = "";
        var day = "";
        var now = date;
        year = "" + now.getFullYear();
        if (now.getMonth() + 1 < 10) {
            month = "0" + (now.getMonth() + 1);
        } else {
            month = "" + (now.getMonth() + 1);
        }
        if (now.getDate() < 10) {
            day = "0" + now.getDate();
        } else {
            day = "" + now.getDate();
        }
        return year + "-" + month + "-" + day;
    }
    /** 
     * 获得相对当前周AddWeekCount个周的起止日期 
     * AddWeekCount为0代表当前周 为-1代表上一个周   为1代表下一个周以此类推
     * 
     **/
    static getWeekStartAndEnd(AddWeekCount) {
        //起止日期数组   
        var startStop = new Array();
        //一天的毫秒数   
        var millisecond = 1000 * 60 * 60 * 24;
        //获取当前时间   
        var currentDate = new Date();
        //相对于当前日期AddWeekCount个周的日期
        currentDate = new Date(currentDate.getTime() + (millisecond * 7 * AddWeekCount));
        //返回date是一周中的某一天
        var week = currentDate.getDay();
        //返回date是一个月中的某一天   
        // var month = currentDate.getDate();

        //减去的天数   
        var minusDay = week != 0 ? week - 1 : 6;
        //获得当前周的第一天   
        var currentWeekFirstDay = new Date(currentDate.getTime() - (millisecond * minusDay));
        //获得当前周的最后一天
        var currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + (millisecond * 6));
        //添加至数组   
        startStop.push(this.getDateStr3(currentWeekFirstDay));
        startStop.push(this.getDateStr3(currentWeekLastDay));

        return startStop;
    }
    /** 
     * 获得相对当月AddMonthCount个月的起止日期 
     * AddMonthCount为0 代表当月 为-1代表上一个月  为1代表下一个月 以此类推
     * ***/
    static getMonthStartAndEnd(AddMonthCount) {
        //起止日期数组
        var startStop = new Array();
        //获取当前时间
        var currentDate = new Date();
        var month = currentDate.getMonth() + AddMonthCount;
        if (month < 0) {
            var n = parseInt(-month / 12);
            month += n * 12;
            currentDate.setFullYear(currentDate.getFullYear() - n);
        }
        currentDate = new Date(currentDate.setMonth(month));
        currentDate.setMonth(month)
        //获得当前月份0-11
        var currentMonth = currentDate.getMonth();
        //获得当前年份4位年
        var currentYear = currentDate.getFullYear();
        //获得上一个月的第一天
        var currentMonthFirstDay = new Date(currentYear, currentMonth, 1);
        //获得上一月的最后一天
        var currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0);
        //添加至数组
        startStop.push(this.getDateStr3(currentMonthFirstDay));
        startStop.push(this.getDateStr3(currentMonthLastDay));
        //返回
        return startStop;
    }

    //从其他页面跳转到跟进页面
    static jumpFollow() {
        // vue.router.push("/Admissioncue/admissionCue");
        window.location.href = "/Admissioncue/admissionCue";
    }

    // 获取表格高度
    static getTableHeight(num) {
        var clientHeight = 0;
        if (document.body.clientHeight && document.documentElement.clientHeight) {
            clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
        } else {
            clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight;
        }
        return clientHeight - num;
    }
    //自定编辑列方式*******设置自定义编辑内容展示数据
    static settingOprateData(fieldColumns) {
        var arr = [];
        var arr2 = [];
        var obj = {};
        // fieldColumns//后台传过来的数据列
        fieldColumns.forEach((item, index) => {
            arr.push({
                key: index,
                label: item.fieldstring,
                disabled: item.custom == "0"
            });
            if (item.show == "0") {
                arr2.push(index);
            }
        });
        obj.data = arr;
        obj.oprateColumn = arr2;
        return obj;
    }

    static getMonthDays(nowYear, myMonth) {
        let monthStartDate = new Date(nowYear, myMonth, 1);
        let monthEndDate = new Date(nowYear, myMonth + 1, 1);
        let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        return days;
    }

    static formatDateFn(date) {
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();
        if (mymonth < 10) {
            mymonth = '0' + mymonth;
        }
        if (myweekday < 10) {
            myweekday = '0' + myweekday;
        }
        return myyear + '-' + mymonth + '-' + myweekday;
    }

    static getAppointedDate(optType, optPageNum) {
        let now = new Date(); // 当前日期
        let nowDayOfWeek = now.getDay(); // 今天本周的第几天
        let nowDay = now.getDate(); // 当前日
        let nowMonth = now.getMonth(); // 当前月
        let nowYear = now.getFullYear(); // 当前年
        let lastMonth = nowMonth - 1;
        let startDate = '';
        let endDate = '';
        if (optType == 1) {
            startDate = this.formatDateFn(
                new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - 7 * optPageNum)
            );
            endDate = this.formatDateFn(
                new Date(nowYear, nowMonth, nowDay + 7 - nowDayOfWeek - 7 * optPageNum)
            );
        } else if (optType == 2) {
            startDate = this.formatDateFn(
                new Date(nowYear, lastMonth + 1 - 1 * optPageNum, 1)
            );
            endDate = this.formatDateFn(
                new Date(
                    nowYear,
                    lastMonth + 1 - 1 * optPageNum,
                    this.getMonthDays(nowYear, lastMonth + 1 - 1 * optPageNum)
                )
            );
        }
        return {
            startDate: startDate,
            endDate: endDate
        };
    }
    static formatTen(num) {
        return num > 9 ? (num + "") : ("0" + num);
    }
    // 日期格式转化为时间格式
    static formatDate(dateStr) {
        var date = new Date(dateStr)
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return year + "-" + this.formatTen(month) + "-" + this.formatTen(day) + " " + this.formatTen(hour) + ":" + this.formatTen(minute) + ":" + this.formatTen(second);
    }
}